export enum ValidationRegexPatterns {
    BasicEmailPattern = "^[a-zA-Z0-9.!#$%&'’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$",
    MultipleEmailPattern = "^\\s*[a-zA-Z0-9.!#$%&'’*+/=?^_`{}~-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)*(?:[,;|\\t\\r\\n ]+[a-zA-Z0-9.!#$%&'’*+/=?^_`{}~-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)*)*\\s*$",
    UnsignedIntegerInputRestriction = "[^0-9]",
    SignedIntegerInputRestriction = "[^-0-9]",
    UnsignedDecimalInputRestriction = "[^0-9\.]",
    SignedDecimalInputRestriction = "[^-0-9\.]"
}